import React from "react";
import PaginationComponent from "components/common/Pagination/index";

const PaPagination = ({
  page = 1,
  totalPages = 1,
  total = 0,
  rows = [],
  perPage = 25,
  loading = false,
  onPageChange,
}) => {
  if (totalPages <= 1 || total <= 0) {
    return null;
  }

  return (
    <div
      className={`mt-4 rounded-xl border border-gray-200 bg-white px-4 py-3 shadow-sm${
        loading ? " pointer-events-none opacity-60" : ""
      }`}
    >
      <PaginationComponent
        page={page}
        totalPages={totalPages}
        totalList={total}
        activeListLength={rows}
        limit={perPage}
        handlePagination={onPageChange}
        newDesign
      />
    </div>
  );
};

export default PaPagination;
